<template>

<div>

  <div v-if="discount">

    <h1>Discount: {{ discount.code }}</h1>

    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="updateDiscount">

        <DiscountFields/>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled><span>Updating...</span></button>
          </div>
          <div v-else>
            <button type="submit" class="button" v-if="userRole == 1"><span>Update discount</span></button>
          </div>
        </div>

      </form>

    </div>

  </div>

</div>

</template>

<script>
import DiscountFields from '@/components/DiscountFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'DiscountEdit',
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      return localStorage.getItem("user_role");
    },
  },
  data () {
    return {
      discount: null,
      errors: null
    }
  },
  components: {
    DiscountFields,
    Errors
  },
  created () {
    this.getDiscount()
  },
  watch: {
    '$route': 'getDiscount'
  },
  methods: {
    getDiscount () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'discounts/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.discount = response.data
      })
    },
    updateDiscount () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'discounts/' + this.$route.params.id, {
        method: 'POST',
        body: JSON.stringify(this.discount),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}
</script>
